// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.register-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #F3F4F6;
}

.register-card {
  background-color: #FFFDFC;
  padding: 4rem;
  border-radius: 0.8rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  width: 90%;
  max-width: 600px;
}

.logo-container {
  display: flex;
  justify-content: center;
  margin-bottom: 3rem;
}

.logo {
  width: 25rem;
  height: auto;
}

.register-card h1 {
  font-size: 2.4rem;
  margin-bottom: 2rem;
  text-align: center;
}

.register-container h3 {
  margin-bottom: 1.5rem;
}

.toggle-password-btn {
  position: absolute;
  right: 1.2rem;
  background: none;
  border: none;
  padding: 0.6rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.toggle-password-btn svg {
  width: 2rem;
  height: 2rem;
  color: #2C3948;
}

.toggle-password-btn:hover svg {
  color: #DA7027;
}

.error-message {
  background-color: #FEF2F2;
  color: #DC2626;
  padding: 1rem;
  border-radius: 0.6rem;
  margin-bottom: 2rem;
  font-size: 1.4rem;
}

.register-footer {
  margin-top: 2.4rem;
}

.login-link {
  font-size: 1.4rem;
  color: #2C3948;
}

.login-link a {
  color: #DA7027;
  text-decoration: none;
  font-weight: 500;
}

.login-link a:hover {
  text-decoration: underline;
}

.form-group.si-acheteur {
  display: flex;
  align-items: center;
  gap: 2rem;
  font-weight: 700;
}

.si-acheteur .bouton-radio {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.si-acheteur .bouton-radio label {
  display: flex;
  align-items: center;
  margin: 0;
}

.si-acheteur label {
  margin: 0;
}


/* Style pour les sections prestataire/acheteur */
.prestataire-section,
.acheteur-form {
  margin-top: 20px;
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Autocomplete styles */
.autocomplete-container {
  position: relative;
}

.autocomplete-list {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 10;
  list-style-type: none;
  padding: 0;
  margin: 0;
  background: white;
  border: 1px solid #ccc;
  border-top: none;
  border-radius: 0 0 5px 5px;
  max-height: 200px;
  overflow-y: auto;
}

.autocomplete-list li {
  padding: 10px;
  cursor: pointer;
}

.autocomplete-list li:hover {
  background-color: #f0f0f0;
}


.organisme-input {
  padding-right: 40px;
  width: 100%;
}

.icon-container {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  display: flex;
  align-items: center;
  height: 100%;
}

/* Section nouvel organisme */
.nouveau-organisme-section {
  background-color: rgba(215, 217, 217, 0.20);
  padding: 15px;
  border-radius: 10px;
  margin: 15px 0;
  border: 1px solid #e9ecef;
}

.nouveau-organisme-section h3 {
  margin-bottom: 1.5rem;
}

/* Bouton "Voir les Conditions Générales" */
.cgv-view-button {
  background-color: #DA7027;
  color: #fff;
  border: none;
  padding: 1.2rem 1.6rem;
  border-radius: 3rem;
  font-size: 1.6rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease;
  text-align: center;
  width: 48%;
}

.cgv-view-button:hover {
  background-color: #bf5d20;
}

.cgv-view-button:focus {
  outline: none;
}

/* Conteneur pour les boutons d'actions */
.form-actions-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-top: 2rem;
}

/* Style pour le bouton de soumission */
.submit-button {
  width: 48% !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  padding: 1.2rem 1.6rem !important;
}

.form-group.cgv-container {
  margin: 2.5rem 0;
  padding: 1.5rem;
  border-radius: 0.8rem;
  background-color: #f8f9fa;
  border: 1px solid #eaeaea;
}

.form-actions-container button {
  width: 48%;
}

.form-actions button:disabled {
  background-color: #ccc !important;
  color: #666 !important;
  cursor: not-allowed;
}

.cgv-accepted-message {
  color: #28a745;
  font-weight: 600;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border: 1px solid #28a745;
  border-radius: 5rem;
  background-color: rgba(40, 167, 69, 0.1);
  width: 100%;
}

.check-icon {
  font-size: 2rem;
}

.cgv-link-button {
  background: none;
  border: none;
  color: #DA7027;
  text-decoration: underline;
  cursor: pointer;
  margin-left: 1rem;
  font-weight: 500;
  padding: 0;
}

.cgv-error {
  color: #DC2626;
  margin-top: 1rem;
  font-size: 1.4rem;
  text-align: center;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/pages/Register/Register.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,qBAAqB;EACrB,6CAA6C;EAC7C,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;;AAGA,iDAAiD;AACjD;;EAEE,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,SAAS;EACT,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,2CAA2C;AAC3C;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,qBAAqB;EACrB,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;EACxC,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".register-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background-color: #F3F4F6;\n}\n\n.register-card {\n  background-color: #FFFDFC;\n  padding: 4rem;\n  border-radius: 0.8rem;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n  width: 90%;\n  max-width: 600px;\n}\n\n.logo-container {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 3rem;\n}\n\n.logo {\n  width: 25rem;\n  height: auto;\n}\n\n.register-card h1 {\n  font-size: 2.4rem;\n  margin-bottom: 2rem;\n  text-align: center;\n}\n\n.register-container h3 {\n  margin-bottom: 1.5rem;\n}\n\n.toggle-password-btn {\n  position: absolute;\n  right: 1.2rem;\n  background: none;\n  border: none;\n  padding: 0.6rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.toggle-password-btn svg {\n  width: 2rem;\n  height: 2rem;\n  color: #2C3948;\n}\n\n.toggle-password-btn:hover svg {\n  color: #DA7027;\n}\n\n.error-message {\n  background-color: #FEF2F2;\n  color: #DC2626;\n  padding: 1rem;\n  border-radius: 0.6rem;\n  margin-bottom: 2rem;\n  font-size: 1.4rem;\n}\n\n.register-footer {\n  margin-top: 2.4rem;\n}\n\n.login-link {\n  font-size: 1.4rem;\n  color: #2C3948;\n}\n\n.login-link a {\n  color: #DA7027;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.login-link a:hover {\n  text-decoration: underline;\n}\n\n.form-group.si-acheteur {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n  font-weight: 700;\n}\n\n.si-acheteur .bouton-radio {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n}\n\n.si-acheteur .bouton-radio label {\n  display: flex;\n  align-items: center;\n  margin: 0;\n}\n\n.si-acheteur label {\n  margin: 0;\n}\n\n\n/* Style pour les sections prestataire/acheteur */\n.prestataire-section,\n.acheteur-form {\n  margin-top: 20px;\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Autocomplete styles */\n.autocomplete-container {\n  position: relative;\n}\n\n.autocomplete-list {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  z-index: 10;\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  background: white;\n  border: 1px solid #ccc;\n  border-top: none;\n  border-radius: 0 0 5px 5px;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.autocomplete-list li {\n  padding: 10px;\n  cursor: pointer;\n}\n\n.autocomplete-list li:hover {\n  background-color: #f0f0f0;\n}\n\n\n.organisme-input {\n  padding-right: 40px;\n  width: 100%;\n}\n\n.icon-container {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n  display: flex;\n  align-items: center;\n  height: 100%;\n}\n\n/* Section nouvel organisme */\n.nouveau-organisme-section {\n  background-color: rgba(215, 217, 217, 0.20);\n  padding: 15px;\n  border-radius: 10px;\n  margin: 15px 0;\n  border: 1px solid #e9ecef;\n}\n\n.nouveau-organisme-section h3 {\n  margin-bottom: 1.5rem;\n}\n\n/* Bouton \"Voir les Conditions Générales\" */\n.cgv-view-button {\n  background-color: #DA7027;\n  color: #fff;\n  border: none;\n  padding: 1.2rem 1.6rem;\n  border-radius: 3rem;\n  font-size: 1.6rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  text-align: center;\n  width: 48%;\n}\n\n.cgv-view-button:hover {\n  background-color: #bf5d20;\n}\n\n.cgv-view-button:focus {\n  outline: none;\n}\n\n/* Conteneur pour les boutons d'actions */\n.form-actions-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n  margin-top: 2rem;\n}\n\n/* Style pour le bouton de soumission */\n.submit-button {\n  width: 48% !important;\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  padding: 1.2rem 1.6rem !important;\n}\n\n.form-group.cgv-container {\n  margin: 2.5rem 0;\n  padding: 1.5rem;\n  border-radius: 0.8rem;\n  background-color: #f8f9fa;\n  border: 1px solid #eaeaea;\n}\n\n.form-actions-container button {\n  width: 48%;\n}\n\n.form-actions button:disabled {\n  background-color: #ccc !important;\n  color: #666 !important;\n  cursor: not-allowed;\n}\n\n.cgv-accepted-message {\n  color: #28a745;\n  font-weight: 600;\n  padding: 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  border: 1px solid #28a745;\n  border-radius: 5rem;\n  background-color: rgba(40, 167, 69, 0.1);\n  width: 100%;\n}\n\n.check-icon {\n  font-size: 2rem;\n}\n\n.cgv-link-button {\n  background: none;\n  border: none;\n  color: #DA7027;\n  text-decoration: underline;\n  cursor: pointer;\n  margin-left: 1rem;\n  font-weight: 500;\n  padding: 0;\n}\n\n.cgv-error {\n  color: #DC2626;\n  margin-top: 1rem;\n  font-size: 1.4rem;\n  text-align: center;\n  font-weight: 500;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
